import { useState } from 'react';
import { useLeads } from '../hooks/useLeads';
import { useContent } from '../hooks/useContent';
import { buildExcelReport, buildPdfReport } from '../lib/reports';
import { isoWeekKey, startOfWeek } from '../lib/metrics';

export default function Reports() {
  const { leads, loading } = useLeads();
  const { targets } = useContent();
  const [weekRef, setWeekRef] = useState(toDateInput(new Date()));
  const [busy, setBusy] = useState(null);

  const weekDate = new Date(weekRef);
  const wk = isoWeekKey(startOfWeek(weekDate));

  async function dl(kind) {
    setBusy(kind);
    try {
      if (kind === 'xlsx') buildExcelReport(leads, { weekDate, targets });
      else buildPdfReport(leads, { weekDate });
    } finally { setBusy(null); }
  }

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-2xl font-semibold mb-2">Weekly reports</h1>
      <p className="text-sm text-slate-600 mb-6">
        Generate the same scorecard structure as your existing B1S 2026 CRM workbook,
        plus a one-page PDF for sharing.
      </p>

      <div className="card p-5 space-y-4">
        <div>
          <label className="label">Reporting week</label>
          <input type="date" className="input max-w-xs" value={weekRef} onChange={e => setWeekRef(e.target.value)} />
          <div className="text-xs text-slate-500 mt-1">Week: <strong>{wk}</strong></div>
        </div>

        <div className="flex flex-wrap gap-2">
          <button disabled={loading || !!busy} onClick={() => dl('xlsx')} className="btn-primary">
            {busy === 'xlsx' ? 'Building…' : '⬇ Download Excel (.xlsx)'}
          </button>
          <button disabled={loading || !!busy} onClick={() => dl('pdf')} className="btn-ghost border border-slate-200">
            {busy === 'pdf' ? 'Building…' : '⬇ Download PDF'}
          </button>
        </div>
      </div>

      <h2 className="text-lg font-semibold mt-8 mb-2">What's in each report</h2>
      <div className="card p-5 text-sm space-y-2 text-slate-700">
        <div><strong>Excel</strong>: 4 sheets — Pipeline (full lead dump in original column order), KPI Dashboard (12-week scorecard with targets/totals), Channel Attribution, and a Weekly Summary for the selected week.</div>
        <div><strong>PDF</strong>: one-pager with headline KPIs, stage funnel, 12-week scorecard, and top-10 deals by value.</div>
      </div>
    </div>
  );
}

function toDateInput(d) { return d.toISOString().slice(0, 10); }
